import React from 'react';
import {connect} from 'react-redux';
import Loader from 'components/atoms/loaders/loader';
import {GameComponent} from './game';
import Action from 'actions';
import Const from 'constants';
import AllGamesChecking from './all-games-checking';
import {sortByProperty} from 'helpers/sorters';
import {BaseComponent as Component} from 'BaseComponent';

class FilterByGames extends Component {
    componentDidMount() {
        this.loadSlateIfGamesNotLoaded();
    }

    componentDidUpdate(prevProps) {
        this.loadSlateIfGamesNotLoaded();
    }

    clickOnGame(gameTeams) {
        const {playersFilter} = this.props;

        let teams = playersFilter.games.slice(),
            isTeamFound = teams.some((team) => inArray(team, gameTeams));

        if (isTeamFound) {
            teams = teams.filter((team) => !inArray(team, gameTeams));
        } else {
            teams = teams.concat(gameTeams);
        }

        this.props.dispatch(Action.set('GamesFilter', teams));
        this.props.dispatch(Action.do('filterByTeam', Const.PLAYERS_TEAM_FILTER_ALL));
    }

    clickOnTeam(team) {
        const {playersFilter} = this.props;

        const teams = playersFilter.games.slice();
        const index = teams.indexOf(team);

        if (index === -1) {
            teams.push(team);
        } else {
            teams.splice(index, 1);
        }

        this.props.dispatch(Action.set('GamesFilter', teams));
        this.props.dispatch(Action.do('filterByTeam', Const.PLAYERS_TEAM_FILTER_ALL));
    }

    getGamesFilterView() {
        const {games} = this.props;

        if (games.isLoading()) {
            return <Loader />;
        } else if (!games.hasGames()) {
            return <div className="not-found-text">Games were not found.</div>;
        }

        const sortedGames = games.getAllAsArr().sort(sortByProperty('gameTimestamp'));

        return sortedGames.map((game, index) => {
            return (
                <GameComponent
                    key={index}
                    game={game}
                    clickOnGameCallback={::this.clickOnGame}
                    clickOnTeamCallback={::this.clickOnTeam}
                />
            );
        });
    }

    getAllGamesCheckingView() {
        const {games} = this.props;

        if (games.hasMoreThanOneGame()) {
            return <AllGamesChecking />;
        }

        return null;
    }

    render() {
        const {sportConfig} = this.props;

        return (
            <div className={`game-filter-block sport-${sportConfig.getSport()}`}>
                <label className="label-alt">Games Filter</label>
                <div className="game-filter-wrap">
                    {this.getAllGamesCheckingView()}
                    {this.getGamesFilterView()}
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        playersData: {games, filters},
    } = state;

    return {
        games,
        sportConfig,
        playersFilter: filters,
    };
}

const FilterByGamesComponent = connect(mapStatesToProps)(FilterByGames);

export {FilterByGamesComponent};
